import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GoalInformationDialogComponent } from 'src/app/dialogs/goal-information-dialog/goal-information-dialog.component';
import { GoalInformation } from 'src/app/enums/goal-information.enum';
import { GoalPermissionsHelper } from 'src/app/helpers/goal-permissions.helper';
import { IResultModel, ResultModel } from 'src/app/models/general/result.model';
import { GoalPage } from 'src/app/models/goal-page.model';
import { GroupGoal, GroupGoalModel } from 'src/app/models/group-goal.model';
import { GroupGoalsData } from 'src/app/models/group-goals-data.model';
import { GroupGoalsPage } from 'src/app/models/group-goals-page.model';
import { GroupGoalsSaveModel } from 'src/app/models/group-goals-save.model';
import { State } from 'src/app/models/state.model';
import { StateService } from 'src/app/services';
import { GroupGoalService } from 'src/app/services/group-goal.service';
import { ErrorMessageService } from 'src/app/shared/services';

@UntilDestroy()
@Component({
  selector: 'app-group-goal',
  templateUrl: './group-goal.component.html',
  styleUrl: './group-goal.component.scss'
})
export class GroupGoalComponent {
    
  // route: group-goals

  public data: GroupGoalsPage;
  public state: State;

  public groupGoalData: GroupGoalsData;
  
  public get isSelf(): boolean {
    return this.state?.me.value?.employee?.id === this.data?.goalPeriod.employeeId;
  }

    constructor(
      private router: Router,
      private route: ActivatedRoute,
      private groupGoalService: GroupGoalService,
      stateService: StateService,
      private msgService: ErrorMessageService,
      private dialog: MatDialog
    ) { 
      this.state = stateService.state;
    }
  
    ngOnInit(): void {

      this.route.params.pipe(untilDestroyed(this)).subscribe((params) => {
          const goalPeriodId = params['goalPeriodId'] ? parseInt(params['goalPeriodId']) : null;
     
          if (goalPeriodId) {
            
            this.groupGoalService
                .getGroupGoals(goalPeriodId)
                .subscribe((pageData) => {      
          
                this.data = pageData;

                if (this.allowAddNew() && this.data.goalPeriod.groupGoals.length === 0)
                {
                  this.addNew();
                }

                this.groupGoalData = new GroupGoalsData();
                this.groupGoalData.goalPeriodId = this.data.goalPeriod.id;
                this.groupGoalData.isSelf = this.isSelf;
                this.groupGoalData.groupGoals = this.data.leaderGroupGoals;
              });
          }

      });

      
    }

    getBackLink(): string {
      return `/goals/${this.data?.goalPeriod.reviewPeriod.id}/${this.data?.goalPeriod.employeeId}`;
    }
  
    allowAddNew(): boolean {
      return GoalPermissionsHelper.canGroupGoalAddNew(this.data?.goalPeriod, this.state);
    }

    addNew() {
        let groupGoal = new GroupGoalModel();
        groupGoal.goalPeriodId = this.data?.goalPeriod.id;

        this.data?.goalPeriod.groupGoals.push(groupGoal);
    }
  
    itemAdded(groupGoal: GroupGoal) {
      const index = this.data.goalPeriod.groupGoals.findIndex(x => x.id == 0);
      this.data.goalPeriod.groupGoals[index] = groupGoal;
    }
  
    itemDeleted(id: number) {
      this.data.goalPeriod.groupGoals = this.data.goalPeriod.groupGoals.filter(gg => gg.id != id);
    }

    public isFormValid(): boolean {
      return this.data?.goalPeriod.groupGoals.every(gg => gg.name);
    }

    public onOk() {
      if (!this.isFormValid())
      {
        this.msgService.showSnackBarMessage('fillAllMarkedFields');
        return;
      }


      let model = {
        goalPeriodId: this.data.goalPeriod.id,
        groupGoals: this.data.goalPeriod.groupGoals
      } as GroupGoalsSaveModel;

      this.groupGoalService.saveGroupGoals(model)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (result) => {
            this.router.navigate([this.getBackLink()]);
          },
          error: (err: IResultModel<ResultModel>) => {
            this.msgService.handleError<ResultModel>(err);
          }
        }
      );
    }

    showInformation(): void {
        this.dialog.open(GoalInformationDialogComponent, {
              width: "850px",
              data: { goalInfoType: GoalInformation.GroupGoals }
        });
    }
}
